module.exports = __webpack_public_path__ + "media/images/order-cancel-a9e9d3c758215c050a14522ef2ace049.svg";